const validateKebabCasedString = (value) => {
  const regex = /^([a-z0-9]*)([-.][a-z0-9]+)*$/;
  const kebabCasedStringValid = regex.test(value);
  return kebabCasedStringValid;
};

export { validateKebabCasedString };
